import { useEffect, useState,useRef} from 'react'
import './pages.css'
import AxiosURL from '../../ApiService/AxiosURL';
import  emitter  from "./emitter";  

export default function Breadcrumb({setvalue}) {
  
  // API call
  let API="farmers/breadcrumb";
  let distt = "farmers/get_districts";


  const [useDistricts, setDistricts] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [getVillages, setVillages] = useState([]);
  const [useSelected, setSelected] = useState();
  const [getFarmers, setFarmers] = useState([]);
  const [getDist, setDist] = useState([]);
  const [getVill, setVill] = useState([]);
  const [users, setUsers] = useState([]);
  useEffect(()=>{
    fetchApiData(API);
    fetchDistricts(distt);
    
  },[]);
  const fetchApiData = async(url)=>{
    try{
      const response = await AxiosURL.get(url);
      setUsers(response.data.data);
        }catch(error){
      console.log(error);      
    }
  };
  const fetchDistricts = async(url)=>{
    try{
         const response = await AxiosURL.get(url);
         setDistricts(response.data.data);
    }catch(error){
      console.log(error);
    }
  }
  const filteredByDistrict = async (tval)=>{
    if(tval.target.value == 'select')
    {
      fetchApiData(API);
    }else{
      setVillages([]);
      setIsLoading(true);
      var distData = tval.target.value;
      const response = await AxiosURL.get(API,{ params:{"district": distData}});
      setUsers(response.data.data);
      emitter.emit("sendFilterData",{"district": distData})
      setIsLoading(false);

      // get Village district wise
      const resp = await AxiosURL.get('farmers/get_village/'+distData);
      setVillages(resp.data.data);
      // console.log(resp.data.data);
    }    
  }
  const filteredByVillage = async (villVal)=>{
    if(villVal.target.value=='select')
    {
      const response = await AxiosURL.get(API,{ params:{"district": getDist}});
      setUsers(response.data.data);
      emitter.emit("sendFilterData",{"district": getDist})
    }
    else
    {
      var villData = villVal.target.value;
      const response = await AxiosURL.get(API,{ params:{"district": getDist,"village":villData}});
      setUsers(response.data.data);
      emitter.emit("sendFilterData",{"district": getDist, "village": villData});
      
      let distData = villVal.target.value;
      // get farmers village wise
      const resp = await AxiosURL.get('farmers/get_farmer/'+distData);
      setFarmers(resp.data.data);
      // console.log(resp.data.data);

    }
  }
  const filteredByFarmers = async(farmerVal)=>{
    if(farmerVal.target.value=='select')
    {
      const response = await AxiosURL.get('farmers/get_village/',{params:{"district":getDist,"village":+getVill}});
      setUsers(response.data.data);
      emitter.emit("sendFilterData",{"village":getVill})
    }
    else{
      var farmerData = farmerVal.target.value;
      const response = await AxiosURL.get(API,{params:{"district": getDist,"village":getVill, 'farmer':farmerData}});
      setUsers(response.data.data);
      emitter.emit("sendFilterData",{"district": getDist, "village": getVill, "farmer":farmerData});
    }
  }
  const selectInputRef = useRef();
  var RoleId = localStorage.getItem('role_id');
  const hideShowVillage = (props) =>{
    var length = props.length;
    var villageId = document.getElementById('villageId');
      if(length=='' || props=='select')
      {
        // villageId.style.display = "none";
      }
      else{
        // villageId.style.display = "block";
      }
  }
  
  return (
    <>
      <div className='row'>
      <div className="box"> 
      {RoleId==2 ?                      
  <span>
  <select className="form selectTag"  aria-label="Default select example search_select"  onChange={(value)=>{filteredByDistrict(value); setDist(value.target.value); hideShowVillage(value.target.value);}} >
    <option  selected>Select District</option>
             {useDistricts.map((data,i)=>{
              return <option key={i} value={data.district}>{data.district}</option>
             })}  
  </select>
  <select className="form selectTag"   aria-label="Default select example search_select" onChange={(value)=>filteredByVillage(value)}  style={{marginLeft:5}}
        ref={selectInputRef}  >
    <option value={0} >Select Village</option>
            {
            getVillages.length===0
            ? "<option value={0} >Select Village</option>"
             :getVillages.map((data,i)=>{
              return <option key={i} value={data.village}>{data.village}</option>
             })
             }
  </select>
  </span>
  : '' }
</div>
<div className="box"> 
      {RoleId==3 ?                      
  <span>
  <select className="form selectTag3"  aria-label="Default select example search_select"  onChange={(value)=>{filteredByDistrict(value); setDist(value.target.value); hideShowVillage(value.target.value);}} >
    <option  selected>Select District</option>
             {useDistricts.map((data,i)=>{
              return <option key={i} value={data.district}>{data.district}</option>
             })}  
  </select>
  <select className="form selectTag3"   aria-label="Default select example search_select" onChange={(value)=>{filteredByVillage(value); setVill(value.target.value);}}  style={{marginLeft:5}} 
        ref={selectInputRef}  >
    <option value={0} >Select Village</option>
            {
            getVillages.length===0
            ? "<option value={0} >Select Village</option>"
             :getVillages.map((data,i)=>{
              return <option key={i} value={data.village}>{data.village}</option>
             })
             }
  </select>
  <select className="form selectTag3"   aria-label="Default select example search_select" onChange={(value)=>filteredByFarmers(value)}  style={{marginLeft:5}}
        ref={selectInputRef}  >
          
    <option value={0} >Select Farmer</option>
            {
            getFarmers.length===0
            ? "<option value={0} >Select Farmer</option>"
             :getFarmers.map((data,i)=>{
              return <option key={i} value={data.name}>{data.name}</option>
             })
             }
  </select>
  </span>
  : '' }
</div>
<br />
      </div>
   </>
  )
}
